import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { outputButtonLabels, outputPath } from "./model";
import type { Output } from "./types";

/** A project's outputs as dark buttons ("Abstract ↗"), one per output — used on the Home project cards. */
const OutputLinks = ({ projectId, outputs, className }: { projectId: string; outputs: Output[]; className?: string }) => {
  if (outputs.length === 0) return null;
  const labels = outputButtonLabels(outputs);

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {outputs.map((o) => (
        <Link
          key={o.id}
          to={outputPath(projectId, o.id)}
          title={o.title || undefined}
          className="relative z-10 inline-flex items-center gap-1.5 bg-brand-navy px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-teal transition-colors"
        >
          {labels.get(o.id)}
          <ArrowUpRight className="w-4 h-4" />
        </Link>
      ))}
    </div>
  );
};

export default OutputLinks;
